import { HTMLAttributes } from 'react';
import { Controller } from 'react-hook-form';
import { MarketButton } from '@market/react';

export const CONTROLLED_BUTTON_TEST_ID = 'controlled-button-test-id';

export type ControlledButtonProps = HTMLAttributes<HTMLElement> & {
  // form control
  control?: any;
  name?: string;
  shouldUnregister?: boolean;

  // market button props
  label?: string;
  rank?: HTMLMarketButtonElement['rank'];
  type?: HTMLMarketButtonElement['type'];
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  onSubmit?: (event) => void;
};

const ControlledButton = ({
  className,
  control,
  name,
  shouldUnregister = false,
  type,
  rank = 'primary',
  label,
  disabled,
  isLoading,
  onClick,
  onSubmit,
}: ControlledButtonProps) => {
  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({ field, formState: { isSubmitting } }) => (
        <MarketButton
          {...field}
          data-testid={CONTROLLED_BUTTON_TEST_ID}
          className={className}
          rank={rank}
          type={type}
          disabled={disabled || isSubmitting}
          isLoading={isSubmitting || isLoading}
          {...(onClick && { onClick })}
          {...(onSubmit && { onSubmit })}
        >
          {label}
        </MarketButton>
      )}
    />
  );
};

export default ControlledButton;
